import PhotoDefault from '../../../../shared/assets/images/png/photoDefault.png';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import DeviceConfig from '@devices/config';

interface Props {
  height: number;
  width: number;
  src: string;
}

const SliderBackground = styled.img<Props>`
  display: flex;
  height: ${720 * Screen.widthRatio}px;
  object-fit: ${() =>
    DeviceConfig.capabilities.image.disableFitCover ? 'unset' : 'cover'};
  overflow: hidden;
  position: relative;
  width: ${1920 * Screen.widthRatio}px;
  z-index: 1;
`;

SliderBackground.defaultProps = {
  src: PhotoDefault,
};

export default withImage(SliderBackground, true);
